import {
    SetCurrentCameraAction,
    CameraDataInterface,
    SetCameraStreamStatusAction,
    SetCurrentCamerasAction,
    SetOpenedCameraListAction,
    ResetStreamsAction,
    SetInitAllStreamStatusAction,
    SetInitOneStreamStatusAction,
    SetCurrentStreamAction,
    SetCameraStreamFetchAction, 
    SetPTZModeAction, 
    SetCapibilitiesAction, 
    SetPresetsAction, 
    SetCameraListSearchQueryAction,
    SetDeviceStatusAction,
    SetCameraReloadAction,
    ClearPaneAction
} from "./types";

import {
    CAMERAS_RESET_STREAMS,
    CAMERAS_SET_CAMERAS_STREAM_ERROR,
    CAMERAS_SET_CAMERAS_STREAM_FETCH,
    CAMERAS_SET_CAMERAS_STREAM_STATUS,
    CAMERAS_SET_CAMERAS_STREAM_SUCCESS, CAMERAS_SET_CAPIBILITIES,
    CAMERAS_SET_CURRENT_CAMERA,
    CAMERAS_SET_CURRENT_CAMERAS,
    CAMERAS_SET_CURRENT_STREAMS,
    CAMERAS_SET_INIT_ALL_STREAM_STATUS,
    CAMERAS_SET_INIT_ONE_STREAM_STATUS, CAMERAS_SET_PRESETS,
    CAMERAS_SET_PTZ_MODE, CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY, 
    CAMERAS_SET_DEVICE_STATUS, CAMERAS_SET_CAMERA_RELOAD, CAMERAS_CLEAR_PANE
} from "../../constants/cameras";


export const setCurrentCamera = (camera: CameraDataInterface, pane: number) : SetCurrentCameraAction => ({
        type: CAMERAS_SET_CURRENT_CAMERA,
        pane: pane,
        camera: camera
    });

export const setCurrentCameras = (cameras: any): SetCurrentCamerasAction => ({type: CAMERAS_SET_CURRENT_CAMERAS, cameras });

export const clearPane = (pane: number): ClearPaneAction => ({type: CAMERAS_CLEAR_PANE, pane });

export const setCameraListSearchQuery = (query: string): SetCameraListSearchQueryAction => ({type: CAMERAS_SET_CAMERA_LIST_SEARCH_QUERY, query });

export const setCurrentStream = (pane: number, stream: any, camId: string) : SetCurrentStreamAction => ({type: CAMERAS_SET_CURRENT_STREAMS, pane, stream, camId});

export const setInitALLStreamStatus = (streams: any): SetInitAllStreamStatusAction => ({type: CAMERAS_SET_INIT_ALL_STREAM_STATUS, streams });

export const setInitOneStreamStatus = (pane: number): SetInitOneStreamStatusAction => ({type: CAMERAS_SET_INIT_ONE_STREAM_STATUS, pane });

export const setCameraStreamFetch = (pane: number, requestId: string): SetCameraStreamFetchAction => ({
    type: CAMERAS_SET_CAMERAS_STREAM_FETCH,
    requestId: requestId,
    pane: pane
});

export const setCameraStreamSuccess = (payload: string, pane: number) => ({
    type: CAMERAS_SET_CAMERAS_STREAM_SUCCESS,
    pane: pane,
    payload: payload
});

export const setCameraStreamError = (payload: string, pane: number) => ({
    type: CAMERAS_SET_CAMERAS_STREAM_ERROR,
    pane: pane,
    payload: payload
});

export const setCameraStreamStatus = (payload: {data: string, status: string}, pane: number) : SetCameraStreamStatusAction => ({
    type: CAMERAS_SET_CAMERAS_STREAM_STATUS,
    pane: pane,
    streamStatus: payload
});

export const setCameraStreamName = (options: any) : any => ({
    type: 'getStreamName',
    options: options
});

export const resetStreams = () : ResetStreamsAction => ({type: CAMERAS_RESET_STREAMS});

export const setOpenedCameraList = (opened: boolean) : SetOpenedCameraListAction => ({type: 'setOpenedCameraList', opened});

export const setPTZMode = (pane: number, ptzMode: boolean) : SetPTZModeAction => ({type: CAMERAS_SET_PTZ_MODE, pane, ptzMode});

export const setCapibilities = (data: any, pane: number) : SetCapibilitiesAction => ({type: CAMERAS_SET_CAPIBILITIES, data, pane});

export const setPresets = (presets: string[], pane: number) : SetPresetsAction => ({type: CAMERAS_SET_PRESETS, presets, pane});

export const setDeviceStatus = (pane: number, status: string) : SetDeviceStatusAction => ({type: CAMERAS_SET_DEVICE_STATUS, pane, status});

export const setCameraReload = (pane: number) : SetCameraReloadAction => ({type: CAMERAS_SET_CAMERA_RELOAD, pane});

//******************* browse ****************
